var EvaluationAPI = require("../../../../common/api").Evaluation;
var RepositoryAPI = require("../../../../common/api").Repository;

module.exports = function($scope, $window, applicationEvaluationLabels, application, canEditApplication, isFunder){

  $scope.selected = "";
  $scope.selectedReportDetails = [];
  $scope.applicationEvaluationLabels = applicationEvaluationLabels;
  $scope.application = application;
  $scope.canEditApplication = canEditApplication;
  $scope.isFunder = isFunder;


  $scope.select = function(index) {
    $scope.selected = index;
  };

  $scope.selectReport = function(report){
    $scope.applicationEvaluationLabels.forEach(function(exrep) {
      if(exrep.reportId != report.reportId){
        exrep.showReport = false;
      }
    })
    getReportDetails(report);
    report.showReport = true;
  }

  getReportDetails = function(report){
     EvaluationAPI.GetEvaluationReportDetails(report.reportId).then(function(results){
      $scope.selectedReportDetails = results;
    })
  }

  $scope.downloadPrivateFile = function(document){
      RepositoryAPI.GetRepoToken(document.documentId, false, true).then(function(token) {
        var formattedId = (document.documentId).replace(/-/g, '');
        var url = window.conf.doc_repos_url + "dl/"
        + encodeURIComponent(formattedId) + "/"
        + document.fileName
        + "?t=" + encodeURIComponent(token);

        //download file here (use default window behaviour)
        $window.location.href = url;
      })
  }

  $scope.downloadPublicFile = function(document){
        var formattedId = (document.documentId).replace(/-/g, '');
        var url = window.conf.doc_repos_url + "get/"
        + encodeURIComponent(formattedId) + "/"
        + document.fileName;

        //download file here (use default window behaviour)
        $window.location.href = url;
  }
}
